/* exported bocAmchart4 */
/* global am4core */

/**
 * Container object for Bank of Canada functions for setting up AmCharts
 */
var bocAmchart4 = {};
am4core.options.autoSetClassName = true;
am4core.options.deferredDelay = 0;
am4core.options.minPolylineStep = 3;
am4core.options.queue = true;


/**
 * Version file, listing the features implemented, latest at the end of the array (under features),
 * make sure to separate the tasks to avoid merge conflicts
 * The entries could be deleted after they are code released on prod (not via uploads)
 * @type {{svn: string, features: string[]}}
 */
bocAmchart4.version = {
    "svn": "$Revision: 34965 $".match(/\$Revision:\s*(\d+)\s*\$/)[1],
    "date": "$Date: 2025-03-12 11:24:14 -0400 (Wed, 12 Mar 2025) $".match(/\$Date:\s*(.+)\s*\$/)[1],
    "features": {}
};

bocAmchart4.version.features['DEV-9087-Amcharts Analytics changes'] = [
    'Changed the Amcharts google analytics with new event names and parameters',
    'Use gtag instead of gtagEvent',
    'Move debug message to gtag',
    'Truncate debug by 40 for event and 100 for params',
    'Updated debug message',
    'Add new chart_series parameters to legend hide and show events',
    'Only calls gtag when analytics is enabled',
    'Fix bug in truncating debug message',
    'Modify debug for edge cases',
    'Cleanup code'
];

bocAmchart4.version.features['DEV-9215-Make-addArrow-addLabels-work-for dates'] = [
    'Added code to handle dates for arrows and labels',
    'Adding change details to params.js'
];

bocAmchart4.version.features['DEV-9383-Review-amchart4-formatting-and-add-explanations-to-params.'] = [
    'Updated some params and clarified where formatting can be used',
    'Applied formatting to guidelines labels',
    'Applied the Amcharts4 formatting to scatter labels override and to tooltips',
    'Cleaning up some linebreaks and camelcase in params.js',
    'Adding horizontalCenter parameter and clarifying the params.js for it',
    "Fix for the order of appearance for comparison signs in heatmap tooltips",
    "Fixing the dark mode color for period value and pie labels",
    "Added data-arrow0.. parameters to replace addArrow callbacks",
    "Added data-label0.. parameters to replace addLabels callbacks",
    "Added data-customBullets0.. parameters to replace addCustomBullet callbacks",
    "Modified amcharts Behat to use new parameters and documented them",
    "Added printOverride parameter and deleted custom bullets function documentation",
    "Added data-seriesLabelsFontsize parameter"
];

bocAmchart4.version.features['DEV-9377-FSR-Charts-support'] = [
    'Fixed color for chart scrollbar inactive portion',
    'Fixed legend for 30 color column on dark mode'
];

bocAmchart4.version.features['DEV-9511-XYChart-bands'] = [
    'Properly added handling for the case of xy chart using bands'
];

bocAmchart4.version.features['DEV-9363-Heatmap-legend-labels-are-missing-on-print'] = [
    'set label data outside of listener',
    'moved logic into functions to improve readability'
];

bocAmchart4.version.features['DEV-9546-addArrow-function-doesnt-align-arrow'] = [
    'Updated z-index and alignment of arrow tip'
];

bocAmchart4.version.features['DEV-9632-Show-notes-button-should-appear-before-the-hr'] = [
    'Appending notes button right after the notes container'
];
bocAmchart4.version.features['DEV-9600-fix-@amcharts4-behat-tests'] = [
    'remove period value labels from dom if not being used'
];
